export const colors = {
  primary: "#E3AF25",
  backgroundSecondary: "#121212",
  darkGray: "#1E1E1E"
};
